import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

export default function DashboardChartCard({
  title,
  unit,
  icon: Icon,
  children,
  sx,
}) {
  return (
    <Card component="section" sx={{ height: '100%', ...sx }}>
      <CardContent
        sx={{
          height: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          p: { xs: 2, md: 2.5 },
          '&:last-child': { pb: { xs: 2, md: 2.5 } },
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          spacing={0.75}
          sx={{ mb: 2 }}
        >
          <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0 }}>
            <Icon color="action" fontSize="small" />
            <Stack spacing={0.15} sx={{ minWidth: 0 }}>
              <Typography component="h2" variant="subtitle1" sx={{ fontSize: { xs: 17, md: 18 }, fontWeight: 750, lineHeight: 1.3 }}>
                {title}
              </Typography>
            </Stack>
          </Stack>
          {unit && (
            <Typography variant="caption" color="text.disabled" sx={{ flexShrink: 0, fontWeight: 600 }}>
              {unit}
            </Typography>
          )}
        </Stack>
        <Box sx={{ flex: 1, minWidth: 0, minHeight: 0 }}>{children}</Box>
      </CardContent>
    </Card>
  );
}
